import find from "lodash/find"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"

import {
  ACCOUNT_LINKING_ZIPLOGIX,
  ACCOUNT_LINKING_CAR,
  PARTNER_DISPLAY_NAME,
  ACCOUNT_LINKING_TAR
} from "../containers/page-connect-account/constants"
import { getCDNImage, resizeWithImageProxy } from "./image"

export const showPartnerButton = (subdomain, ssoDetails) =>
  ssoDetails && !!find(ssoDetails, ["subdomain", subdomain])

export const getPartnerLogoAuth = subdomain =>
  subdomain && subdomain.length && subdomain !== "rentspree"
    ? getCDNImage(`/logos/${subdomain}-nav-logo.png`)
    : ""

export const getPartnerLogoDashboard = subdomain =>
  subdomain && subdomain.length && subdomain !== "rentspree"
    ? getCDNImage(`/logos/${subdomain}-logo.png`)
    : ""

export const getPartnerLogo = (subdomain, ssoDetails) =>
  showPartnerButton(subdomain, ssoDetails) ? getPartnerLogoAuth(subdomain) : ""

export const ssoLinkingList = (ssoList, partnerConnects) =>
  [
    ...ssoList.filter(item => get(item, "accountLinking")).map(item => {
      const { subdomain, name, accountLinking } = item
      const partnerLogo = getPartnerLogo(subdomain, ssoList)
      const { imgHeight = "50px" } = item.accountLinking
      // Double image height for quality (not blur)
      const doubleImgHeight = parseInt(imgHeight.replace(/\D/g, ""), 10) * 2
      const imgSrc = resizeWithImageProxy(partnerLogo, {
        height: doubleImgHeight
      })

      return {
        id: subdomain,
        provider: subdomain,
        imgSrc,
        imgAlt: name,
        name,
        ...accountLinking
      }
    }),
    {
      ...ACCOUNT_LINKING_CAR,
      name: "California Association of Realtors",
      imgSrc: resizeWithImageProxy(getPartnerLogoAuth("car"), {
        height: 100
      }),
      enableRedirectSubdomain: false,
      defaultRedirectSubdomain: ""
    },
    {
      ...ACCOUNT_LINKING_TAR,
      name: "Texas Realtors",
      imgSrc: resizeWithImageProxy(getPartnerLogoAuth("tar"), {
        height: 100
      }),
      enableRedirectSubdomain: false,
      defaultRedirectSubdomain: ""
    },
    {
      ...ACCOUNT_LINKING_ZIPLOGIX,
      name: PARTNER_DISPLAY_NAME.ziplogix,
      tags: [
        "zipform",
        "ziplogix",
        "lonewolf",
        "lone wolf",
        "transaction desk"
      ],
      imgSrc: resizeWithImageProxy(getPartnerLogoAuth("ziplogix"), {
        height: 80
      }),
      enableRedirectSubdomain: false,
      defaultRedirectSubdomain: ""
    }
  ].map(data => {
    let integrationData = {}
    // TODO: remove this entire if-branch when the legacy NRDS CAR entry is removed
    if (data.id === ACCOUNT_LINKING_CAR.id) {
      const partnerConnection = get(partnerConnects, data.provider, {})
      integrationData =
        partnerConnection?.integrationType === "car"
          ? partnerConnection.partnerId
          : ""
    } else {
      integrationData = get(partnerConnects, data.provider, {})
    }

    if (!isEmpty(integrationData)) {
      return {
        ...data,
        [data.showBy]: integrationData[data.showBy],
        isConnected: true
      }
    }
    return {
      ...data,
      isConnected: false
    }
  })

/**
 * Show only one CAR entry:
 * - if legacy (NRDS) CAR is connected, show it for unlink and hide SSO CAR
 * - otherwise show SSO CAR and hide the legacy entry
 */
export const filterCarSsoPartners = partners => {
  const { id: nrdsCarId } = ACCOUNT_LINKING_CAR
  const ssoCarId = "car"

  const nrdsCarConnected = partners.find(partner => partner.id === nrdsCarId)
    ?.isConnected

  const idToRemove = nrdsCarConnected ? ssoCarId : nrdsCarId

  return partners.filter(partner => partner.id !== idToRemove)
}
